module.exports = __webpack_public_path__ + "static/media/screen-lookup.96b91611.png";